<template>
    <div class="container">
      <QueryFrame
        @handlePage='handlePage'
        @handlePageSize='handlePageSize'
        :count='count'
        :disablePage='disablePage'
        :current="page">
        <div slot="queryParams" class="form">
          <div class="queryContainer">
            <div class="queryItem">
              <label>医保处方编号:</label>
              <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.rxNo'></lk-input>
            </div>
            <div class="queryItem">
              <label>医院名称:</label>
              <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.hospitalName'></lk-input>
            </div>
            <div class="queryItem">
              <label>患者姓名:</label>
              <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.patnName'></lk-input>
            </div>
            <div class="queryItem">
              <label>开方时间:</label>
              <timeStampDatePicker type="daterange" v-model='query.date' class="item"></timeStampDatePicker>
            </div>
            <div class="queryItem">
              <label>处方状态:</label>
              <lk-select clearable class="item" v-model='query.status'>
                <lk-option v-for="item in statusList" :key="item.id" :value="item.id">
                  {{item.name}}
                </lk-option>
              </lk-select>
            </div>
            <div class="queryItem">
              <label>销售订单号:</label>
              <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.saleOrderCode'></lk-input>
            </div>
            <div class="queryItem">
              <label>门店:</label>
              <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
            </div>
            <div class="queryItem">
              <lk-button class="mr" type='primary' @click="getData">查询</lk-button>
              <lk-button @click="clear">重置</lk-button>
            </div>
          </div>
        </div>
        <div slot="table">
           <div class="btn-wrap mb16">
              <lk-button class="mr8" type="primary" @click="exchangeRecipe" v-if="handlePermission('recipeExchange')">流转处方</lk-button>
              <span style="margin-left:20px">处方审核通过后，请在收银台中引用处方创建销售订单</span>
           </div>
          <lk-table border :columns='columns' :data='tableData'></lk-table>
        </div>
      </QueryFrame>
      <lk-modal title="提示" v-model="recallAlert" :footer-hide='true' width="400">
        <div style="display:flex; margin-left: 10px;">
            <span class="warnIcon iconfont">&#xe613;</span> &nbsp;
            <div style="margin-top: 6px;">是否确认撤销处方？</div>
        </div>
        <div class="bottomButton">
            <lk-button type='primary' @click="handleRecall">确认</lk-button>
            <lk-button @click="recallAlert = false">取消</lk-button>
        </div>
    </lk-modal>
    <lk-modal title="流转处方" v-model="showReadCard" :footer-hide='true' width="1100">
        <div style="max-height:480px;overflow:auto">
          <div style="display:flex;height:60px;align-items:center;">
            <div style="margin: 0 18px 0 10px">医保科目:</div>
            <div>
              <lk-radio-group v-model="insSub">
                <lk-radio v-for='item in subjectList' :key="item.id" :label='item.id'>
                  <span>{{item.name}}</span>
                </lk-radio>
              </lk-radio-group>
            </div>
          </div>
          <div class="cardArea">
            <div class="cardLeft">
              <div class="cardType">卡类型:</div>
              <div>
                <lk-radio-group v-model="cardType">
                  <lk-radio v-for='item in cardList' :key="item.id" :label='item.id'>
                    <span>{{item.name}}</span>
                  </lk-radio>
                </lk-radio-group>
              </div>
            </div>
            <div style="display:flex; align-items:center" class="cardRight" v-if="isNeedPassWord && cardType != 1">
              医保卡密码：<lk-input type="password" style="width:200px" placeholder="请输入医保卡密码" v-model="password"></lk-input>
            </div>
            <div style="display:flex; align-items:center" class="cardRight" v-if='cardType == 1 && ifShowScanNum'>
              电子医保卡：<lk-input style="width:200px" :disabled="healthDisabled" placeholder="请扫码电子医保二维码" v-model="healthNum"></lk-input>
            </div>
            <div class="cardRight" style="margin-top: -20px;">
              <lk-button type='primary' @click='handleClick' :disabled='cardStatus' :loading="btnCardLoading">读卡</lk-button>
            </div>
          </div>
          <div class="cardArea">
            <div class="cardLeft" style="margin-left: -10px;height:30px">
              <div class="cardType">人员类型:</div>
              <div>
                <lk-radio-group v-model="personType">
                  <lk-radio v-for='item in personTypeList' :key="item.id" :label='item.id'>
                    <span>{{item.name}}</span>
                  </lk-radio>
                </lk-radio-group>
              </div>
            </div>
          </div>
        </div>
        <lk-form :label-width='120' label-position="right">
            <lk-card title='' class="cardContainer" :bordered="false" style="background:#F3F7F9">
                <lk-row :gutter='16' style="background:#F3F7F9">
                  <lk-col span='8'><lk-form-item  label='人员编号:'><span>{{cardInfoObj.psnNo}}</span></lk-form-item></lk-col>
                  <lk-col span='8'><lk-form-item  label='人员姓名:'><span>{{cardInfoObj.psnName}}</span></lk-form-item></lk-col>
                  <lk-col span='8'><lk-form-item  label='证件类型:'><span>{{cardInfoObj.psnCertTypeName}}</span></lk-form-item></lk-col>
                </lk-row>
                <lk-row :gutter='16' style="background:#F3F7F9">
                  <lk-col span='8'><lk-form-item  label='证件号码:'><span>{{cardInfoObj.certno}}</span></lk-form-item></lk-col>
                  <lk-col span='8'><lk-form-item label='性别:'><span>{{cardInfoObj.gendName}}</span></lk-form-item></lk-col>
                  <lk-col span='8'><lk-form-item  label='民族:'><span>{{cardInfoObj.natyName}}</span></lk-form-item></lk-col>
                </lk-row>
                <lk-row :gutter='16' style="background:#F3F7F9">
                  <lk-col span='8'><lk-form-item  label='出生日期:'><span>{{cardInfoObj.brdy}}</span></lk-form-item></lk-col>
                  <lk-col span='8'><lk-form-item  label='年龄:'><span>{{cardInfoObj.age}}</span></lk-form-item></lk-col>
                </lk-row>
            </lk-card>
        </lk-form>
        <div class="infoButton">
            <lk-button type='primary' :disabled="searchDisabled" @click="handleSearchRecipe">查询处方</lk-button>
        </div>
      </lk-modal>
      <lk-modal
        v-model="recipeModal"
        title="流转处方"
        :width="1100"
        :mask-closable='false'
        @on-cancel="modalCancel"
        :footer-hide='true'
        >
        <div>
            <div class="queryContainer">
                <label style="color:gray">&nbsp;&nbsp;请选择处方:</label>
            </div>
          <lk-table class='mb8' highlight-row :data='recipeList' :columns='recipeCol' border
          ></lk-table>
        </div>
        <div class="infoButton">
            <lk-button type='primary' :disabled="userDisabled" @click="handleUsed">确认使用</lk-button>
        </div>
      </lk-modal>
      <bjReadCard :showRead="showBJRC" @closeModal="closeBJModal" @handleSearchRecipe="handleSearchBJRecipe" > </bjReadCard>
    </div>
  </template>
<script>

import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import healthInsManage from '../../services/healthInsManage';
import storeUtils from '../../libs/storeUtil';
import bjReadCard from './BeiJingReadCard';

export default {
  name: 'doubleChannelRecipe',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    bjReadCard,
  },
  computed: {
    isNeedPassWord() {
      return storeUtils.isNeedPassword(this.$store.state.storeInfo.id);
    },
    ifShowScanNum() {
      return this.$store.state.storeInfo.id === 10; // rd: 125，测试：399，线上：深圳：62， 佛山：10
    },
  },
  data() {
    return {
      recallAlert: false,
      recipeModal: false,
      userDisabled: true,
      searchDisabled: true,
      cardInfoObj: {},
      personType: 1,
      btnCardLoading: false,
      cardStatus: false,
      healthDisabled: false,
      healthNum: '', // 医保码
      password: '',
      cardType: 3,
      insSub: 0,
      showReadCard: false,
      refuseReason: '',
      errorModal: false,
      subjectList: [
        { id: 0, name: '市医保' }, { id: 1, name: '省医保' },
      ],
      cardList: [
        { id: 3, name: '医保卡' }, { id: 2, name: '身份证' }, { id: 1, name: '电子医保卡' },
      ],
      personTypeList: [
        {
          id: 1,
          name: '中国大陆',
        },
        {
          id: 2,
          name: '港澳台',
        },
        {
          id: 3,
          name: '外国人',
        },
      ],
      showAlert: false,
      disablePage: false,
      statusList: [
        {
          id: 1,
          name: '待审核',
        },
        {
          id: 2,
          name: '已审核',
        },
        {
          id: 3,
          name: '已使用',
        },
        {
          id: 4,
          name: '待撤销',
        },
        {
          id: 5,
          name: '已撤销',
        },
        {
          id: 6,
          name: '审核未通过',
        },
      ],
      query: {
        rxNo: '', // 处方编号
        hospitalName: '', // 医院名称
        patnName: '', // 患者姓名
        prscStartTime: '', // 开始
        prscEndTime: '', // 截止时间
        status: '', // 处方状态
        saleOrderCode: '', // 销售单号
        storeIdList: [], // 门店id
        date: [],
      },
      createTimeStartOption: this.createTimeStartOptions(),
      createTimeEndOption: this.createTimeEndOptions(),
      columns: [
        {
          title: '序号', key: 'purchaseRefundStoreName', type: 'index', minWidth: 50,
        },
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        { title: '医保处方编号', key: 'rxNo', minWidth: 136 },
        {
          title: '医院名称',
          key: 'fixmedinsName',
          minWidth: 116,
          tooltip: true,
        },
        { title: '科室', key: 'prscDeptName', minWidth: 116 },
        { title: '患者姓名', key: 'patnName', minWidth: 116 },
        {
          title: '开方时间',
          key: 'prscTime',
          minWidth: 136,
          render: (h, params) => h('span', utils.formatTime(params.row.prscTime)),
        },
        {
          title: '有效截止时间',
          key: 'valiEndTime',
          minWidth: 136,
          render: (h, params) => h('span', utils.formatTime(params.row.valiEndTime)),
        },
        { title: '处方状态', key: 'statusName', minWidth: 116 },
        { title: '审方药师', key: 'pharName', minWidth: 116 },
        {
          title: '审核时间',
          key: 'rxChkTime',
          minWidth: 136,
          render: (h, params) => h('span', utils.formatTime(params.row.rxChkTime)),
        },
        { title: '销售订单号', key: 'saleOrderCode', minWidth: 166 },
        {
          title: '操作',
          key: 'action',
          // fixed: 'right',
          width: 140,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            this.handlePermission('recipePass') && params.row.status == 1 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'recipeDetail', params: { id: params.row.id } });
                },
              },
            }, '处方审核') : null,
            this.handlePermission('recipeRecall') && params.row.status == 4 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.rxId = params.row.id;
                  this.recallAlert = true;
                },
              },
            }, '撤销') : '',
            this.handlePermission('recipeDetail') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'recipeDetail', params: { id: params.row.id } });
                },
              },
            }, '查看') : null,
          ]),
        },
      ],
      tableData: [],
      printPaperSize: 5,
      recipeList: [],
      recipeCol: [
        {
          title: ' ',
          minWidth: 50,
          render: (h, params) => h('div', [
            h('lk-radio-group', {
              props: {
                value: params.row.select,
              },
              on: {
                'on-change': (status) => {
                  this.recipeList.forEach((item) => {
                    this.$set(item, 'select', params.row.authRxno == item.authRxno ? 1 : 0);
                  });
                  this.userDisabled = false;
                },
              },
            }, [
              h('lk-radio', {
                props: {
                  label: 1,
                },
              }, ''),
            ]),
          ]),
        },
        { title: '医保处方授权编号', key: 'authRxno', minWidth: 116 },
        { title: '开方医院编号', key: 'fixmedinsCode', minWidth: 116 },
        { title: '开方医院名称', key: 'fixmedinsName', minWidth: 116 },
        { title: '科室', key: 'deptName', minWidth: 116 },
        { title: '病种编码', key: 'diseCodg', minWidth: 116 },
        { title: '病种名称', key: 'diseName', minWidth: 116 },
        {
          title: '开方时间',
          key: 'prscTime',
          minWidth: 136,
          render: (h, params) => h('span', utils.formatTime(params.row.prscTime)),
        },
        {
          title: '有效截止时间',
          key: 'valiEndTime',
          minWidth: 136,
          render: (h, params) => h('span', utils.formatTime(params.row.valiEndTime)),
        },
      ],
      showBJRC: false,
    };
  },
  methods: {
    handleUsed() {
      const rxNo = this.recipeList.filter(item => item.select == 1)[0].hiRxno;
      const authRxno = this.recipeList.filter(item => item.select == 1)[0].authRxno;
      const epcToken = this.recipeList.filter(item => item.select == 1)[0].epcToken;
      healthInsManage.dowloadRx({ rxNo, authRxno, epcToken }).then((res) => {
        if (res.data.status === 200) {
          this.recipeModal = false;
          if (this.handlePermission('recipeLook') || this.handlePermission('recipePass') || this.handlePermission('recipeRecall')) {
            this.$router.push({ name: 'recipeDetail', params: { id: res.data.data.id } });
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    modalCancel() {
      this.recipeModal = false;
    },
    handleSearchRecipe() { // 查询医保局处方
      this.recipeModal = true;
      const tempParams = {
        psnCertType: this.cardInfoObj.psnCertType,
        psnName: this.cardInfoObj.psnName,
        certno: this.cardInfoObj.certno,
        mdtrt_cert_no: this.cardInfoObj.mdtrt_cert_no,
      };
      this.showReadCard = false;
      this.recipeList = [];
      healthInsManage.querRx(tempParams).then((res) => {
        if (res.data.status === 200) {
          this.recipeList = res.data.data;
          this.recipeList.forEach((item) => {
            this.$set(item, 'select', 0);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleRecall() { // 处方撤销
      healthInsManage.rxSaleWrif({ rxId: this.rxId }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('撤销成功');
          this.recallAlert = false;
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    gotoDetail() {
      this.$router.push({ name: 'recipeDetail', params: { id: 1 } });
    },
    // 清空检索项
    clear() {
      this.query = {};
    },
    getData() {
      this.query.page = this.page;
      this.query.size = this.size;
      if (Object.keys('query').includes('date') && this.query.date.length) {
        delete this.query.date;
        this.query.prscStartTime = null;
        this.query.prscEndTime = null;
      } else {
        this.query.prscStartTime = this.query.date[0] || null;
        this.query.prscEndTime = this.query.date[1] || null;
      }
      healthInsManage.recipeList(this.query).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          this.tableData = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    exchangeRecipe() {
      this.healthDisabled = false;
      this.cardInfoObj = {};
      this.cardStatus = false;
      this.searchDisabled = true;
      if (this.$store.state.storeInfo.id == 7) {
        this.showBJRC = true;
      } else {
        this.showReadCard = true;
      }
    },
    isSheetAble(status) {
      if ((status === 3 || status === 6) && this.handlePermission('refundSheet')) {
        return true;
      }
      return false;
    },
    // 是否可以修改 status 状态 1草稿 2审核中 3审核通过 4审核未通过 （无状态）6海典完成状态
    isEditAble(status) {
      if ((status === 1 || status === 4) && this.handlePermission('supplierRefundEdit')) {
        return true;
      }
      return false;
    },
    isDeleteAble(status) {
      if (status === 1 && this.handlePermission('supplierRefundDeleteBtn')) {
        return true;
      }
      return false;
    },
    isPrintAble(status) {
      // 3:已出库  6：审核通过 7：取消中 8：待出库
      if ([3, 6, 7, 8].includes(status) && this.handlePermission('supplierRefundPrint')) {
        return true;
      }
      return false;
    },
    createTimeStartOptions() {
      const vm = this;
      return {
        disabledDate(time) {
          if (vm.query.createTimeEnd) {
            return time.getTime() > vm.query.createTimeEnd;// 开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    createTimeEndOptions() {
      const vm = this;
      return {
        disabledDate(time) {
          if (vm.query.createTimeStart) {
            return time.getTime() < vm.query.createTimeStart;// 开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    handleClick() {
      if (this.cardType == 1 && (this.healthNum == '' || this.healthNum == undefined) && this.ifShowScanNum) {
        this.$Message.error('请填写码电子医保');
        return;
      }
      if (storeUtils.isNeedPassword(this.$store.state.storeInfo.id)) {
        if (!this.password && this.cardType === 3) {
          this.$Message.error('请填写密码');
          return;
        }
        this.handleReadCard();
      } else {
        this.handleReadCard();
      }
    },
    handleReadCard() { // 读卡成功
      let obj = {
        type: this.cardType, // 固定： 1 电子医保卡
        personType: this.personType, // 大陆： 1
        operate: 1,
        pass: this.password,
        medicalSubject: this.insSub, // 1 市医保
        ecToken: this.healthNum,
      };
      this.btnCardLoading = true;
      healthInsManage.readCard(obj).then((res) => {
        this.btnCardLoading = false;
        if (res.data.status === 200) {
          this.healthDisabled = true;
          this.$Message.success('读卡成功');
          this.cardInfoObj = res.data.data || {};
          this.cardStatus = true;
          this.searchDisabled = false;
        } else {
          this.$Message.error(res.data.error);
        }
        this.btnCardLoading = false;
      }).catch((err) => {
        this.btnCardLoading = false;
        utils.handleError(err);
      });
    },
    closeBJModal() {
      this.showBJRC = false;
    },
    handleSearchBJRecipe(e) {
      this.showBJRC = false;
      this.recipeModal = true;
      this.cardInfoObj = e;
      const tempParams = {
        psnName: this.cardInfoObj.icInfo.personname,
        gend: this.cardInfoObj.icInfo.sex,
      };
      this.showReadCard = false;
      this.recipeList = [];
      healthInsManage.querRx(tempParams).then((res) => {
        if (res.data.status === 200) {
          this.recipeList = res.data.data;
          this.recipeList.forEach((item) => {
            this.$set(item, 'select', 0);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
  <style lang="less" scoped>
  .bottomButton{
    margin-left: 220px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
  }
  .warnIcon {
  color: orange;
  font-size: 20px;
};
.infoButton{
    margin-left: 970px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
  }
  .cardLeft {
    display: flex;
    margin-bottom: 20px;
    .cardType {
      margin: 0 20px;
    }
  }

  .cardContainer .ivu-form .ivu-form-item-label {
    font-weight: 500;
  }
  .cardArea {
    height: 50px;
    display: flex;
    align-items: center;
    .cardLeft {
      display: flex;
      .cardType {
        margin: 0 20px;
      }
    }
    .cardRight {
      margin-left: 50px;
    }
  }
  </style>
